(function (angular) {
    "use strict";
    angular.module('smartpublic.core')
        .factory('ComplaintsformFactory', ComplaintsformFactory);

    ComplaintsformFactory.$inject = ['$log', '$http', '$q', 'BASE_URL'];

    function ComplaintsformFactory($log, $http, $q, BASE_URL) {

        return {
            submitComplaint: submitComplaint,
            submitInfoRequest: submitInfoRequest,
            downloadFileRequest: downloadFileRequest
        };


        function submitComplaint(complaint) {
            return $http.post(BASE_URL + 'reclamacao', complaint);
        }

        function submitInfoRequest(request) {
            return $http.post(BASE_URL + 'inforequest', request);
        }

        function downloadFileRequest(filename) {
            return $http.get(BASE_URL + 'download?filename=' + filename);
        }


    }

})
(angular);